export default {
  getMenuPages: ({ pages, selectedOffice }) => (menu) => {
    return pages.filter(p => {
      if ([7, 8].includes(selectedOffice.network_id) && p.assigned_countries && p.assigned_countries.length > 0 && p.assigned_countries.includes('UKA')) {
        return p.published && p.menu_id === menu.id && (p.assigned_network === selectedOffice.network_id || p.assigned_network === null) && (selectedOffice.associate === true || p.assigned_countries.includes(selectedOffice.country))
      } else if ([7, 8].includes(selectedOffice.network_id) && p.assigned_countries && p.assigned_countries.length > 0 && selectedOffice.country !== 'JE') {
        return p.published && p.menu_id === menu.id && (p.assigned_network === selectedOffice.network_id || p.assigned_network === null) && (p.assigned_countries && p.assigned_countries.includes(selectedOffice.country))
      } else if (p.assigned_countries && p.assigned_countries.length > 0 && selectedOffice.country === 'JE') {
        return p.published && p.menu_id === menu.id && (p.assigned_network === 8 || p.assigned_network === null) && (p.assigned_countries && p.assigned_countries.includes(selectedOffice.country))
      }
      if (selectedOffice.role === 'Lite') {
        return p.published && p.menu_id === menu.id && (p.assigned_network === selectedOffice.network_id || p.assigned_network === null) && p.guild_lite === true
      }
      return p.published && p.menu_id === menu.id && (p.assigned_network === selectedOffice.network_id || p.assigned_network === null)
    })
  },
  allMenus ({ menus }) {
    let all = []

    let cb = m => {
      all.push({
        id: m.id,
        parent_id: m.parent_id,
        system_id: m.system_id,
        name: m.name,
        slug: m.slug
      })

      if (m.children && m.children.length > 0) {
        m.children.forEach(cb)
      }
    }

    menus.forEach(cb)

    return all
  }
}
